var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.5a9 9 0 01-9 9v0a9 9 0 01-9-9v0a9 9 0 019-9v0a9 9 0 019 9v0z",
    stroke: "#7D8085",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.438 9.813L11.5 13.75 7.562 9.812",
    stroke: "#7D8085",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMjAuNSAxMS41QzIwLjUgMTYuNDcwNiAxNi40NzA2IDIwLjUgMTEuNSAyMC41VjIwLjVDNi41Mjk0NCAyMC41IDIuNSAxNi40NzA2IDIuNSAxMS41VjExLjVDMi41IDYuNTI5NDQgNi41Mjk0NCAyLjUgMTEuNSAyLjVWMi41QzE2LjQ3MDYgMi41IDIwLjUgNi41Mjk0NCAyMC41IDExLjVWMTEuNVoiIHN0cm9rZT0iIzdEODA4NSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICA8cGF0aCBkPSJNMTUuNDM3NSA5LjgxMjVMMTEuNSAxMy43NUw3LjU2MjUgOS44MTI1IiBzdHJva2U9IiM3RDgwODUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==";
export { SvgExpand as ReactComponent };